// All countries
// length 252
export const countriess = [
  { name: "L'Afghanistan", code: "AF", capital: "Kabul", alpha_3: "AFG" },
  { name: "Iles Aland", code: "AX", capital: "Mariehamn", alpha_3: "ALA" },
  { name: "Albanie", code: "AL", capital: "Tirana", alpha_3: "ALB" },
  { name: "Algérie", code: "DZ", capital: "Algiers", alpha_3: "DZA" },
  {
    name: "Samoa américaines",
    code: "AS",
    capital: "Pago Pago",
    alpha_3: "ASM",
  },
  { name: "Andorre", code: "AD", capital: "Andorra la Vella", alpha_3: "AND" },
  { name: "L'Angola", code: "AO", capital: "Luanda", alpha_3: "AGO" },
  { name: "Anguilla", code: "AI", capital: "The Valley", alpha_3: "AIA" },
  { name: "Antarctique", code: "AQ", capital: "Antarctica", alpha_3: "ATA" },
  {
    name: "Antigua-et-Barbuda",
    code: "AG",
    capital: "St. John's",
    alpha_3: "ATG",
  },
  { name: "Argentine", code: "AR", capital: "Buenos Aires", alpha_3: "ARG" },
  { name: "Arménie", code: "AM", capital: "Yerevan", alpha_3: "ARM" },
  { name: "Aruba", code: "AW", capital: "Oranjestad", alpha_3: "ABW" },
  { name: "Australie", code: "AU", capital: "Canberra", alpha_3: "AUS" },
  { name: "L'Autriche", code: "AT", capital: "Vienna", alpha_3: "AUT" },
  { name: "Azerbaïdjan", code: "AZ", capital: "Baku", alpha_3: "AZE" },
  { name: "Bahamas", code: "BS", capital: "Nassau", alpha_3: "BHS" },
  { name: "Bahreïn", code: "BH", capital: "Manama", alpha_3: "BHR" },
  { name: "Bangladesh", code: "BD", capital: "Dhaka", alpha_3: "BGD" },
  { name: "Barbade", code: "BB", capital: "Bridgetown", alpha_3: "BRB" },
  { name: "Biélorussie", code: "BY", capital: "Minsk", alpha_3: "BLR" },
  { name: "Belgique", code: "BE", capital: "Brussels", alpha_3: "BEL" },
  { name: "Belize", code: "BZ", capital: "Belmopan", alpha_3: "BLZ" },
  { name: "Bénin", code: "BJ", capital: "Porto-Novo", alpha_3: "BEN" },
  { name: "Bermudes", code: "BM", capital: "Hamilton", alpha_3: "BMU" },
  { name: "Bhoutan", code: "BT", capital: "Thimphu", alpha_3: "BTN" },
  { name: "Bolivie", code: "BO", capital: "Sucre", alpha_3: "BOL" },
  {
    name: "Bonaire, Saint-Eustache et Saba",
    code: "BQ",
    capital: "Kralendijk",
    alpha_3: "BES",
  },
  {
    name: "Bosnie Herzégovine",
    code: "BA",
    capital: "Sarajevo",
    alpha_3: "BIH",
  },
  { name: "Botswana", code: "BW", capital: "Gaborone", alpha_3: "BWA" },
  { name: "Île Bouvet", code: "BV", capital: "", alpha_3: "BVT" },
  { name: "Brésil", code: "BR", capital: "Brasilia", alpha_3: "BRA" },
  {
    name: "Territoire britannique de l'océan Indien",
    code: "IO",
    capital: "Diego Garcia",
    alpha_3: "IOT",
  },
  {
    name: "Brunei Darussalam",
    code: "BN",
    capital: "Bandar Seri Begawan",
    alpha_3: "BRN",
  },
  { name: "Bulgarie", code: "BG", capital: "Sofia", alpha_3: "BGR" },
  { name: "Burkina Faso", code: "BF", capital: "Ouagadougou", alpha_3: "BFA" },
  { name: "Burundi", code: "BI", capital: "Bujumbura", alpha_3: "BDI" },
  { name: "Cambodge", code: "KH", capital: "Phnom Penh", alpha_3: "KHM" },
  { name: "Cameroun", code: "CM", capital: "Yaounde", alpha_3: "CMR" },
  { name: "Canada", code: "CA", capital: "Ottawa", alpha_3: "CAN" },
  { name: "Cap-Vert", code: "CV", capital: "Praia", alpha_3: "CPV" },
  { name: "Îles Caïmans", code: "KY", capital: "George Town", alpha_3: "CYM" },
  {
    name: "République centrafricaine",
    code: "CF",
    capital: "Bangui",
    alpha_3: "CAF",
  },
  { name: "Tchad", code: "TD", capital: "N'Djamena", alpha_3: "TCD" },
  { name: "Chili", code: "CL", capital: "Santiago", alpha_3: "CHL" },
  { name: "Chine", code: "CN", capital: "Beijing", alpha_3: "CHN" },
  {
    name: "L'île de noël",
    code: "CX",
    capital: "Flying Fish Cove",
    alpha_3: "CXR",
  },
  {
    name: "Îles Cocos (Keeling)",
    code: "CC",
    capital: "West Island",
    alpha_3: "CCK",
  },
  { name: "Colombie", code: "CO", capital: "Bogota", alpha_3: "COL" },
  { name: "Comores", code: "KM", capital: "Moroni", alpha_3: "COM" },
  { name: "Congo", code: "CG", capital: "Brazzaville", alpha_3: "COG" },
  {
    name: "Congo, République démocratique du Congo",
    code: "CD",
    capital: "Kinshasa",
    alpha_3: "COD",
  },
  { name: "les Îles Cook", code: "CK", capital: "Avarua", alpha_3: "COK" },
  { name: "Costa Rica", code: "CR", capital: "San Jose", alpha_3: "CRI" },
  {
    name: "Côte d'Ivoire",
    code: "CI",
    capital: "Yamoussoukro",
    alpha_3: "CIV",
  },
  { name: "Croatie", code: "HR", capital: "Zagreb", alpha_3: "HRV" },
  { name: "Cuba", code: "CU", capital: "Havana", alpha_3: "CUB" },
  { name: "Curacao", code: "CW", capital: "Willemstad", alpha_3: "CUW" },
  { name: "Chypre", code: "CY", capital: "Nicosia", alpha_3: "CYP" },
  { name: "République Tchèque", code: "CZ", capital: "Prague", alpha_3: "CZE" },
  { name: "Danemark", code: "DK", capital: "Copenhagen", alpha_3: "DNK" },
  { name: "Djibouti", code: "DJ", capital: "Djibouti", alpha_3: "DJI" },
  { name: "Dominique", code: "DM", capital: "Roseau", alpha_3: "DMA" },
  {
    name: "République dominicaine",
    code: "DO",
    capital: "Santo Domingo",
    alpha_3: "DOM",
  },
  { name: "Equateur", code: "EC", capital: "Quito", alpha_3: "ECU" },
  { name: "Egypte", code: "EG", capital: "Cairo", alpha_3: "EGY" },
  { name: "Le Salvador", code: "SV", capital: "San Salvador", alpha_3: "SLV" },
  { name: "Guinée Équatoriale", code: "GQ", capital: "Malabo", alpha_3: "GNQ" },
  { name: "Érythrée", code: "ER", capital: "Asmara", alpha_3: "ERI" },
  { name: "Estonie", code: "EE", capital: "Tallinn", alpha_3: "EST" },
  { name: "Ethiopie", code: "ET", capital: "Addis Ababa", alpha_3: "ETH" },
  {
    name: "Îles Falkland (Malvinas)",
    code: "FK",
    capital: "Stanley",
    alpha_3: "FLK",
  },
  { name: "Îles Féroé", code: "FO", capital: "Torshavn", alpha_3: "FRO" },
  { name: "Fidji", code: "FJ", capital: "Suva", alpha_3: "FJI" },
  { name: "Finlande", code: "FI", capital: "Helsinki", alpha_3: "FIN" },
  { name: "France", code: "FR", capital: "Paris", alpha_3: "FRA" },
  { name: "Guyane Française", code: "GF", capital: "Cayenne", alpha_3: "GUF" },
  {
    name: "Polynésie française",
    code: "PF",
    capital: "Papeete",
    alpha_3: "PYF",
  },
  {
    name: "Terres australes françaises",
    code: "TF",
    capital: "Port-aux-Francais",
    alpha_3: "ATF",
  },
  { name: "Gabon", code: "GA", capital: "Libreville", alpha_3: "GAB" },
  { name: "Gambie", code: "GM", capital: "Banjul", alpha_3: "GMB" },
  { name: "Géorgie", code: "GE", capital: "Tbilisi", alpha_3: "GEO" },
  { name: "Allemagne", code: "DE", capital: "Berlin", alpha_3: "DEU" },
  { name: "Ghana", code: "GH", capital: "Accra", alpha_3: "GHA" },
  { name: "Gibraltar", code: "GI", capital: "Gibraltar", alpha_3: "GIB" },
  { name: "Grèce", code: "GR", capital: "Athens", alpha_3: "GRC" },
  { name: "Groenland", code: "GL", capital: "Nuuk", alpha_3: "GRL" },
  { name: "Grenade", code: "GD", capital: "St. George's", alpha_3: "GRD" },
  { name: "Guadeloupe", code: "GP", capital: "Basse-Terre", alpha_3: "GLP" },
  { name: "Guam", code: "GU", capital: "Hagatna", alpha_3: "GUM" },
  { name: "Guatemala", code: "GT", capital: "Guatemala City", alpha_3: "GTM" },
  { name: "Guernesey", code: "GG", capital: "St Peter Port", alpha_3: "GGY" },
  { name: "Guinée", code: "GN", capital: "Conakry", alpha_3: "GIN" },
  { name: "Guinée-Bissau", code: "GW", capital: "Bissau", alpha_3: "GNB" },
  { name: "Guyane", code: "GY", capital: "Georgetown", alpha_3: "GUY" },
  { name: "Haïti", code: "HT", capital: "Port-au-Prince", alpha_3: "HTI" },
  { name: "Îles Heard et McDonald", code: "HM", capital: "", alpha_3: "HMD" },
  {
    name: "Saint-Siège (État de la Cité du Vatican)",
    code: "VA",
    capital: "Vatican City",
    alpha_3: "VAT",
  },
  { name: "Honduras", code: "HN", capital: "Tegucigalpa", alpha_3: "HND" },
  { name: "Hong Kong", code: "HK", capital: "Hong Kong", alpha_3: "HKG" },
  { name: "Hongrie", code: "HU", capital: "Budapest", alpha_3: "HUN" },
  { name: "Islande", code: "IS", capital: "Reykjavik", alpha_3: "ISL" },
  { name: "Inde", code: "IN", capital: "New Delhi", alpha_3: "IND" },
  { name: "Indonésie", code: "ID", capital: "Jakarta", alpha_3: "IDN" },
  {
    name: "Iran (République islamique d",
    code: "IR",
    capital: "Tehran",
    alpha_3: "IRN",
  },
  { name: "Irak", code: "IQ", capital: "Baghdad", alpha_3: "IRQ" },
  { name: "Irlande", code: "IE", capital: "Dublin", alpha_3: "IRL" },
  {
    name: "île de Man",
    code: "IM",
    capital: "Douglas, Isle of Man",
    alpha_3: "IMN",
  },
  { name: "Israël", code: "IL", capital: "Jerusalem", alpha_3: "ISR" },
  { name: "Italie", code: "IT", capital: "Rome", alpha_3: "ITA" },
  { name: "Jamaïque", code: "JM", capital: "Kingston", alpha_3: "JAM" },
  { name: "Japon", code: "JP", capital: "Tokyo", alpha_3: "JPN" },
  { name: "Jersey", code: "JE", capital: "Saint Helier", alpha_3: "JEY" },
  { name: "Jordan", code: "JO", capital: "Amman", alpha_3: "JOR" },
  { name: "Kazakhstan", code: "KZ", capital: "Astana", alpha_3: "KAZ" },
  { name: "Kenya", code: "KE", capital: "Nairobi", alpha_3: "KEN" },
  { name: "Kiribati", code: "KI", capital: "Tarawa", alpha_3: "KIR" },
  {
    name: "République populaire démocratique de Corée",
    code: "KP",
    capital: "Pyongyang",
    alpha_3: "PRK",
  },
  {
    name: "Corée, République de",
    code: "KR",
    capital: "Seoul",
    alpha_3: "KOR",
  },
  { name: "Kosovo", code: "XK", capital: "Pristina", alpha_3: "XKX" },
  { name: "Koweit", code: "KW", capital: "Kuwait City", alpha_3: "KWT" },
  { name: "Kirghizistan", code: "KG", capital: "Bishkek", alpha_3: "KGZ" },
  {
    name: "République démocratique populaire lao",
    code: "LA",
    capital: "Vientiane",
    alpha_3: "LAO",
  },
  { name: "Lettonie", code: "LV", capital: "Riga", alpha_3: "LVA" },
  { name: "Liban", code: "LB", capital: "Beirut", alpha_3: "LBN" },
  { name: "Lesotho", code: "LS", capital: "Maseru", alpha_3: "LSO" },
  { name: "Libéria", code: "LR", capital: "Monrovia", alpha_3: "LBR" },
  {
    name: "Jamahiriya arabe libyenne",
    code: "LY",
    capital: "Tripolis",
    alpha_3: "LBY",
  },
  { name: "Liechtenstein", code: "LI", capital: "Vaduz", alpha_3: "LIE" },
  { name: "Lituanie", code: "LT", capital: "Vilnius", alpha_3: "LTU" },
  { name: "Luxembourg", code: "LU", capital: "Luxembourg", alpha_3: "LUX" },
  { name: "Macao", code: "MO", capital: "Macao", alpha_3: "MAC" },
  {
    name: "Macédoine, ancienne République yougoslave de",
    code: "MK",
    capital: "Skopje",
    alpha_3: "MKD",
  },
  { name: "Madagascar", code: "MG", capital: "Antananarivo", alpha_3: "MDG" },
  { name: "Malawi", code: "MW", capital: "Lilongwe", alpha_3: "MWI" },
  { name: "Malaisie", code: "MY", capital: "Kuala Lumpur", alpha_3: "MYS" },
  { name: "Maldives", code: "MV", capital: "Male", alpha_3: "MDV" },
  { name: "Mali", code: "ML", capital: "Bamako", alpha_3: "MLI" },
  { name: "Malte", code: "MT", capital: "Valletta", alpha_3: "MLT" },
  { name: "Iles Marshall", code: "MH", capital: "Majuro", alpha_3: "MHL" },
  { name: "Martinique", code: "MQ", capital: "Fort-de-France", alpha_3: "MTQ" },
  { name: "Mauritanie", code: "MR", capital: "Nouakchott", alpha_3: "MRT" },
  { name: "Ile Maurice", code: "MU", capital: "Port Louis", alpha_3: "MUS" },
  { name: "Mayotte", code: "YT", capital: "Mamoudzou", alpha_3: "MYT" },
  { name: "Mexique", code: "MX", capital: "Mexico City", alpha_3: "MEX" },
  {
    name: "Micronésie, États fédérés de",
    code: "FM",
    capital: "Palikir",
    alpha_3: "FSM",
  },
  {
    name: "Moldova, République de",
    code: "MD",
    capital: "Chisinau",
    alpha_3: "MDA",
  },
  { name: "Monaco", code: "MC", capital: "Monaco", alpha_3: "MCO" },
  { name: "Mongolie", code: "MN", capital: "Ulan Bator", alpha_3: "MNG" },
  { name: "Monténégro", code: "ME", capital: "Podgorica", alpha_3: "MNE" },
  { name: "Montserrat", code: "MS", capital: "Plymouth", alpha_3: "MSR" },
  { name: "Maroc", code: "MA", capital: "Rabat", alpha_3: "MAR" },
  { name: "Mozambique", code: "MZ", capital: "Maputo", alpha_3: "MOZ" },
  { name: "Myanmar", code: "MM", capital: "Nay Pyi Taw", alpha_3: "MMR" },
  { name: "Namibie", code: "NA", capital: "Windhoek", alpha_3: "NAM" },
  { name: "Nauru", code: "NR", capital: "Yaren", alpha_3: "NRU" },
  { name: "Népal", code: "NP", capital: "Kathmandu", alpha_3: "NPL" },
  { name: "Pays-Bas", code: "NL", capital: "Amsterdam", alpha_3: "NLD" },
  {
    name: "Antilles néerlandaises",
    code: "AN",
    capital: "Willemstad",
    alpha_3: "ANT",
  },
  { name: "Nouvelle Calédonie", code: "NC", capital: "Noumea", alpha_3: "NCL" },
  {
    name: "Nouvelle-Zélande",
    code: "NZ",
    capital: "Wellington",
    alpha_3: "NZL",
  },
  { name: "Nicaragua", code: "NI", capital: "Managua", alpha_3: "NIC" },
  { name: "Niger", code: "NE", capital: "Niamey", alpha_3: "NER" },
  { name: "Nigeria", code: "NG", capital: "Abuja", alpha_3: "NGA" },
  { name: "Niue", code: "NU", capital: "Alofi", alpha_3: "NIU" },
  { name: "l'ile de Norfolk", code: "NF", capital: "Kingston", alpha_3: "NFK" },
  {
    name: "Îles Mariannes du Nord",
    code: "MP",
    capital: "Saipan",
    alpha_3: "MNP",
  },
  { name: "Norvège", code: "NO", capital: "Oslo", alpha_3: "NOR" },
  { name: "Oman", code: "OM", capital: "Muscat", alpha_3: "OMN" },
  { name: "Pakistan", code: "PK", capital: "Islamabad", alpha_3: "PAK" },
  { name: "Palau", code: "PW", capital: "Melekeok", alpha_3: "PLW" },
  {
    name: "Territoire palestinien, occupé",
    code: "PS",
    capital: "East Jerusalem",
    alpha_3: "PSE",
  },
  { name: "Panama", code: "PA", capital: "Panama City", alpha_3: "PAN" },
  {
    name: "Papouasie Nouvelle Guinée",
    code: "PG",
    capital: "Port Moresby",
    alpha_3: "PNG",
  },
  { name: "Paraguay", code: "PY", capital: "Asuncion", alpha_3: "PRY" },
  { name: "Pérou", code: "PE", capital: "Lima", alpha_3: "PER" },
  { name: "Philippines", code: "PH", capital: "Manila", alpha_3: "PHL" },
  { name: "Pitcairn", code: "PN", capital: "Adamstown", alpha_3: "PCN" },
  { name: "Pologne", code: "PL", capital: "Warsaw", alpha_3: "POL" },
  { name: "Le Portugal", code: "PT", capital: "Lisbon", alpha_3: "PRT" },
  { name: "Porto Rico", code: "PR", capital: "San Juan", alpha_3: "PRI" },
  { name: "Qatar", code: "QA", capital: "Doha", alpha_3: "QAT" },
  { name: "Réunion", code: "RE", capital: "Saint-Denis", alpha_3: "REU" },
  { name: "Roumanie", code: "RO", capital: "Bucharest", alpha_3: "ROM" },
  { name: "Fédération Russe", code: "RU", capital: "Moscow", alpha_3: "RUS" },
  { name: "Rwanda", code: "RW", capital: "Kigali", alpha_3: "RWA" },
  { name: "Saint Barthélemy", code: "BL", capital: "Gustavia", alpha_3: "BLM" },
  { name: "Sainte-Hélène", code: "SH", capital: "Jamestown", alpha_3: "SHN" },
  {
    name: "Saint-Christophe-et-Niévès",
    code: "KN",
    capital: "Basseterre",
    alpha_3: "KNA",
  },
  { name: "Sainte-Lucie", code: "LC", capital: "Castries", alpha_3: "LCA" },
  { name: "Saint Martin", code: "MF", capital: "Marigot", alpha_3: "MAF" },
  {
    name: "Saint-Pierre-et-Miquelon",
    code: "PM",
    capital: "Saint-Pierre",
    alpha_3: "SPM",
  },
  {
    name: "Saint-Vincent-et-les-Grenadines",
    code: "VC",
    capital: "Kingstown",
    alpha_3: "VCT",
  },
  { name: "Samoa", code: "WS", capital: "Apia", alpha_3: "WSM" },
  { name: "Saint Marin", code: "SM", capital: "San Marino", alpha_3: "SMR" },
  {
    name: "Sao Tomé et Principe",
    code: "ST",
    capital: "Sao Tome",
    alpha_3: "STP",
  },
  { name: "Arabie Saoudite", code: "SA", capital: "Riyadh", alpha_3: "SAU" },
  { name: "Sénégal", code: "SN", capital: "Dakar", alpha_3: "SEN" },
  { name: "Serbie", code: "RS", capital: "Belgrade", alpha_3: "SRB" },
  {
    name: "Serbie et Monténégro",
    code: "CS",
    capital: "Belgrade",
    alpha_3: "SCG",
  },
  { name: "les Seychelles", code: "SC", capital: "Victoria", alpha_3: "SYC" },
  { name: "Sierra Leone", code: "SL", capital: "Freetown", alpha_3: "SLE" },
  { name: "Singapour", code: "SG", capital: "Singapur", alpha_3: "SGP" },
  { name: "St Martin", code: "SX", capital: "Philipsburg", alpha_3: "SXM" },
  { name: "Slovaquie", code: "SK", capital: "Bratislava", alpha_3: "SVK" },
  { name: "Slovénie", code: "SI", capital: "Ljubljana", alpha_3: "SVN" },
  { name: "Les îles Salomon", code: "SB", capital: "Honiara", alpha_3: "SLB" },
  { name: "Somalie", code: "SO", capital: "Mogadishu", alpha_3: "SOM" },
  { name: "Afrique du Sud", code: "ZA", capital: "Pretoria", alpha_3: "ZAF" },
  {
    name: "Géorgie du Sud et îles Sandwich du Sud",
    code: "GS",
    capital: "Grytviken",
    alpha_3: "SGS",
  },
  { name: "Soudan du sud", code: "SS", capital: "Juba", alpha_3: "SSD" },
  { name: "Espagne", code: "ES", capital: "Madrid", alpha_3: "ESP" },
  { name: "Sri Lanka", code: "LK", capital: "Colombo", alpha_3: "LKA" },
  { name: "Soudan", code: "SD", capital: "Khartoum", alpha_3: "SDN" },
  { name: "Suriname", code: "SR", capital: "Paramaribo", alpha_3: "SUR" },
  {
    name: "Svalbard et Jan Mayen",
    code: "SJ",
    capital: "Longyearbyen",
    alpha_3: "SJM",
  },
  { name: "Swaziland", code: "SZ", capital: "Mbabane", alpha_3: "SWZ" },
  { name: "Suède", code: "SE", capital: "Stockholm", alpha_3: "SWE" },
  { name: "la Suisse", code: "CH", capital: "Berne", alpha_3: "CHE" },
  {
    name: "République arabe syrienne",
    code: "SY",
    capital: "Damascus",
    alpha_3: "SYR",
  },
  {
    name: "Taiwan, Province de Chine",
    code: "TW",
    capital: "Taipei",
    alpha_3: "TWN",
  },
  { name: "Tadjikistan", code: "TJ", capital: "Dushanbe", alpha_3: "TJK" },
  {
    name: "Tanzanie, République-Unie de",
    code: "TZ",
    capital: "Dodoma",
    alpha_3: "TZA",
  },
  { name: "Thaïlande", code: "TH", capital: "Bangkok", alpha_3: "THA" },
  { name: "Timor-Leste", code: "TL", capital: "Dili", alpha_3: "TLS" },
  { name: "Aller", code: "TG", capital: "Lome", alpha_3: "TGO" },
  { name: "Tokelau", code: "TK", capital: "", alpha_3: "TKL" },
  { name: "Tonga", code: "TO", capital: "Nuku'alofa", alpha_3: "TON" },
  {
    name: "Trinité-et-Tobago",
    code: "TT",
    capital: "Port of Spain",
    alpha_3: "TTO",
  },
  { name: "Tunisie", code: "TN", capital: "Tunis", alpha_3: "TUN" },
  { name: "Turquie", code: "TR", capital: "Ankara", alpha_3: "TUR" },
  { name: "Turkménistan", code: "TM", capital: "Ashgabat", alpha_3: "TKM" },
  {
    name: "îles Turques-et-Caïques",
    code: "TC",
    capital: "Cockburn Town",
    alpha_3: "TCA",
  },
  { name: "Tuvalu", code: "TV", capital: "Funafuti", alpha_3: "TUV" },
  { name: "Ouganda", code: "UG", capital: "Kampala", alpha_3: "UGA" },
  { name: "Ukraine", code: "UA", capital: "Kiev", alpha_3: "UKR" },
  {
    name: "Emirats Arabes Unis",
    code: "AE",
    capital: "Abu Dhabi",
    alpha_3: "ARE",
  },
  { name: "Royaume-Uni", code: "GB", capital: "London", alpha_3: "GBR" },
  { name: "États-Unis", code: "US", capital: "Washington", alpha_3: "USA" },
  {
    name: "Îles mineures éloignées des États-Unis",
    code: "UM",
    capital: "",
    alpha_3: "UMI",
  },
  { name: "Uruguay", code: "UY", capital: "Montevideo", alpha_3: "URY" },
  { name: "Ouzbékistan", code: "UZ", capital: "Tashkent", alpha_3: "UZB" },
  { name: "Vanuatu", code: "VU", capital: "Port Vila", alpha_3: "VUT" },
  { name: "Venezuela", code: "VE", capital: "Caracas", alpha_3: "VEN" },
  { name: "Viet Nam", code: "VN", capital: "Hanoi", alpha_3: "VNM" },
  {
    name: "Îles Vierges britanniques",
    code: "VG",
    capital: "Road Town",
    alpha_3: "VGB",
  },
  {
    name: "Îles Vierges américaines, États-Unis",
    code: "VI",
    capital: "Charlotte Amalie",
    alpha_3: "VIR",
  },
  { name: "Wallis et Futuna", code: "WF", capital: "Mata Utu", alpha_3: "WLF" },
  {
    name: "Sahara occidental",
    code: "EH",
    capital: "El-Aaiun",
    alpha_3: "ESH",
  },
  { name: "Yémen", code: "YE", capital: "Sanaa", alpha_3: "YEM" },
  { name: "Zambie", code: "ZM", capital: "Lusaka", alpha_3: "ZMB" },
  { name: "Zimbabwe", code: "ZW", capital: "Harare", alpha_3: "ZWE" },
];
